import React from "react";
import SampleSelfie from "../assets/sample_picture.png";
import OpenCamera from "../assets/OpenCamera.png";
import PhotoCameraBlack from "../assets/PhotoCameraBlack.png";
import WebCam from "./WebCam";

const SelfieComponent = () => (
  <>
    <div
      className="container-fluid p-3 pb-5 pt-2"
      style={{
        maxWidth: "99%",
        overflowX: "hidden",
        background: "#F9FAFB",
      }}
    >
      <div className="header my-2">
        <h1
          style={{
            fontFamily: "Inter",
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: "38px",
            letterSpacing: "0em",
            textAlign: "left",
          }}
        >
          Take a selfie
        </h1>
        <p
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0em",
            textAlign: "left",
            color: "#1E1E24",
          }}
        >
          We’ll compare this with your document
        </p>
        <hr
          style={{
            border: "1px solid #E4E7EC",
          }}
        />
      </div>
      <div className="content">
        <img
          className="w-100"
          style={{ maxWidth: "276.73px" }}
          src={SampleSelfie}
          alt="SampleSelfie"
        />
        <ul
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "400",
            textAlign: "left",
            color: "#667085",
            paddingLeft: "16px",
            paddingTop: "10px",
          }}
        >
          <li style={{ lineHeight: "23px", letterSpacing: "0em" }}>
            Make sure to be in a place with good lighting
          </li>
          <li style={{ lineHeight: "23px", letterSpacing: "0em" }}>
            Make sure your eyes are clearly visible
          </li>
          <li style={{ lineHeight: "23px", letterSpacing: "0em" }}>
            Make sure to remove masks or other items that cover your face.
            Eyeglasses are okay
          </li>
        </ul>
        <div className="py-3">
          {/* MODAL */}
          {/* Button trigger modal */}
          <button
            type="button"
            className="btn btn-outline-light p-0"
            data-toggle="modal"
            data-target="#Modal"
          >
            <img
              className="w-100"
              style={{ maxWidth: "432px" }}
              src={OpenCamera}
              alt="OpenCamera"
            />
          </button>

          {/* Modal */}
          <div
            className="modal fade"
            id="Modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header border-bottom-0 py-2">
                  <h5
                    className="modal-title"
                    style={{ color: "black" }}
                    id="ModalLabel"
                  >
                    Take a selfie
                  </h5>
                  <button
                    type="button"
                    className="close"
                    style={{ color: "black" }}
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body d-flex align-items-center justify-content-center m-0 p-0">
                  <div
                    style={{
                      width: "95%",
                      borderRadius: "4px",
                    }}
                  >
                    {/* <WebcamCapture /> */}
                    <WebCam />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MODAL */}
        </div>
      </div>
    </div>
  </>
);

export default SelfieComponent;
